<template>
	<v-card class="elevation-0" >
		<!-- Alumno nuevo -->
  	<v-alert
      border="bottom"
      type="info"
      text
      dark
    >
      El <b>folio de prospecto</b> es el de CRM (numérico). El <b>folio RH</b> (ejemplo RH-00001) es la autorización de beca empleado y se captura en el recuadro de abajo.
    </v-alert>
		<br/>

		<label><b>Aquí podrás visualizar los datos el alumno a agregar.</b></label>

		<br/>
		<br/>

	<v-card class="shadowCard mb-4">
		<v-card-title primary-title class="text-capitalize py-3">
		  Beca empleado
		</v-card-title>
	  <v-card-text>
	    <label class="pl-0 black--text">Captura el folio RH para aplicar beca 100%. No es el folio del prospecto.</label>
			<v-row>
				<v-col cols="12" md="6">
					<v-text-field
						v-model="alumno.folio_rh"
						label="Folio RH"
						placeholder="RH-00001"
						filled
						dense
						hide-details="auto"
						:loading="validandoFolioRh"
						:error-messages="folioRhError"
						@input="onFolioRhInput($event, aplicarFolioRhAlumno)"
					/>
				</v-col>
				<v-col cols="12" md="6" class="d-flex align-center">
					<v-alert
						v-if="folioRhInfo"
						type="success"
						dense
						text
						class="mb-0"
					>
						<b>{{ folioRhInfo.folio_rh }}</b> — {{ folioRhInfo.trabajador }}
						<div class="caption">Beca 100% autorizada. Continúa con el prospecto del alumno.</div>
					</v-alert>
				</v-col>
			</v-row>
	    <label class="pl-0 black--text mt-3 d-block">O selecciona el empleado ligado al alumno</label>
			<v-row >
				<v-col cols="12">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-autocomplete
	            :items="empleados"
	            v-model="alumno.id_empleado"
	            label="Empleado que utilizará la beca"
	            item-text="nombre_completo"
	            item-value="id_usuario"
	            filled
	            hide-details
	            dense
	            clearable
	            v-bind="attrs"
	            v-on="on"
	          ></v-autocomplete>
						</template>
						<span>Selecciona el empleado que aplicará su beneficio de beca para este alumno</span>
					</v-tooltip>
				</v-col>
			</v-row>
	  </v-card-text>
	</v-card>

		<v-row>
			<v-col cols="12">
				<v-card class="shadowCard" >
		      <v-card-title>
		        Datos del alumno
		      </v-card-title>
		      <v-card-text>
			  	<!-- BUSCAR POR MATRICULA -->
			  	<label class="pl-0 black--text">Prospecto</label>
			  	<div class="text-caption grey--text">Escribe al menos 3 letras (o el folio numérico) para buscar; no se cargan todos los registros.</div>
					<v-row>
						<v-col cols="12" class="pt-0">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-autocomplete
					          filled 
					          dense
					          clearable
					          no-filter
					          v-model="alumno.id_prospecto"
					          :items="itemsProspectosAutocomplete"
					          :loading="loadingProspectos"
					          :search-input.sync="prospectoSearchInput"
					          label="Buscar prospecto"
					          hide-details
					          item-text="datos_completos"
					          item-value="idprospectos"
					          class="mt-4"
					          placeholder="Ej. nombre o folio de prospecto"
					          :no-data-text="textoSinProspectos"
					          @input="onProspectoAutocompleteInput"
					          v-bind="attrs"
					          v-on="on"
					        >
					        </v-autocomplete>
								</template>
								<span>Selecciona el prospecto del cual proviene el alumno</span>
							</v-tooltip>
						</v-col>
					</v-row>

					<v-tooltip bottom color="blue" max-width="300" v-if="!alumno.id_prospecto">
						<template v-slot:activator="{ on, attrs }">
							<v-btn 
								color="red" 
								dark 
								small 
								class="mt-2 text-capitalize" 
								@click="abrirDialogProspecto()"
								tile
								v-bind="attrs"
								v-on="on"
							>
								No existe el prospecto
							</v-btn>
						</template>
						<span>Crear un nuevo prospecto si no existe en la lista</span>
					</v-tooltip>

						<v-divider class="my-4"></v-divider>

			    <!-- Datos generales del alumno -->
			    <label class="pl-0 black--text" >Datos generales</label>
					<v-row v-if="alumno.id_prospecto">
						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="alumno.nombre"
									  label="Nombre"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Ingresa el nombre del alumno</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="alumno.apellido_paterno"
									  label="Ap. Paterno"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Ingresa el apellido paterno del alumno</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="alumno.apellido_materno"
									  label="Ap. Materno"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Ingresa el apellido materno del alumno</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="alumno.edad"
									  label="Edad"
									  type="number"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Ingresa la edad del alumno</span>
							</v-tooltip>
						</v-col>
					</v-row>

					<!-- Datos del contacto -->
					<v-divider class="my-4"></v-divider>
					<label class="pl-0 black--text" >Datos de contacto</label>
					<v-row v-if="alumno.id_prospecto">
						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="alumno.telefono"
									  label="Teléfono"
									  type="number"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Ingresa el teléfono fijo del alumno o tutor</span>
							</v-tooltip>
						</v-col>

						<v-col cols="12" sm="6">
							<v-tooltip bottom color="blue" max-width="300">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
									  filled 
									  dense
									  hide-details
									  v-model="alumno.celular"
									  label="Celular"
									  type="number"
									  v-bind="attrs"
									  v-on="on"
									></v-text-field>
								</template>
								<span>Ingresa el número celular del alumno o tutor</span>
							</v-tooltip>
						</v-col>
					</v-row>
		      </v-card-text>
		    </v-card>
			</v-col>
		</v-row>

		<v-divider class="my-4"></v-divider>

		<v-card class="shadowCard">
			<v-card-title primary-title class="text-capitalize">
			  Datos del tutor
			</v-card-title>
	  <v-card-text>
	    <label class="pl-0 black--text">Datos generales</label>
			<v-row>
				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.nombre"
							  label="Nombre"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el nombre del tutor o padre de familia</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.apellido_paterno"
							  label="Ap. Paterno"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el apellido paterno del tutor</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.apellido_materno"
							  label="Ap. Materno"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el apellido materno del tutor</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.tipo_parentesco"
							  label="Parentezco"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Indica el parentesco con el alumno (padre, madre, abuelo, tío, etc.)</span>
					</v-tooltip>
				</v-col>
			</v-row>

			<v-divider class="my-4"></v-divider>
			<label class="pl-0 black--text">Datos de contacto</label>
			<v-row>
				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.telefono"
							  label="Teléfono"
							  type="number"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el teléfono fijo del tutor</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.celular"
							  label="Celular"
							  type="number"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el número celular del tutor</span>
					</v-tooltip>
				</v-col>
			</v-row>
	  </v-card-text>
		</v-card>


				

		<v-card-actions>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
          	text 
          	@click="dialogAddAlumno.estatus = false"
          	v-bind="attrs"
          	v-on="on"
          >
            Cancelar
          </v-btn>
        </template>
        <span>Cerrar y cancelar el proceso de inscripción</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          	tile
            color="primary"
            @click="steppers.paso = 2"
            v-bind="attrs"
            v-on="on"
          >
            Siguiente
          	<v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>Continuar al siguiente paso para seleccionar grupo</span>
      </v-tooltip>
  	</v-card-actions>


  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <AgregarProspecto     v-if="existeProspecto"             :parametrosProspectos="parametrosProspectos" @saveProspecto="saveProspecto"/>


	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import AgregarProspecto   from '@/components/inscripciones/AgregarProspecto.vue';


  import validarErrores  from '@/mixins/validarErrores'
  import folioRhBecaEmpleado from '@/mixins/folioRhBecaEmpleado'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      AgregarProspecto
    },

    mixins: [ validarErrores, folioRhBecaEmpleado ],

  	props:[
			'grupo',
			'alumno',
			'steppers',
			'hermanos',
			'tutor',
			'dialogAddAlumno',
	  ],

    data: () => ({
    	escuela: 2,
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      cantidadHermanos: 1,

      respuestaAlerta:false,
      cargar: false,

			step:1,
			isTutor:true,

			opcion:1,

			posicionHermano: 0,

			empleados:[],
			sonHermanos:false,
			existeMatricula: false,
    	/** Resultados de la última búsqueda (servidor); no guardar cientos de miles en memoria. */
    	prospectosBusqueda: [],
    	prospectoElegido: null,
    	prospectoSearchInput: '',
    	loadingProspectos: false,
    	_debounceProspectos: null,
    	parametrosProspectos:{
    		estatus: false
    	},
    	existeProspecto:false,
    	prospecto: null,
    	prospectoSeleccionado: null,
    	alumnos:[],

    	alertaSeguridad: false,

    	headers:[
    		{ text: 'Nombre'       , value: 'nombre'       },
        { text: 'Telefono'     , value: 'telefono'     },
        { text: 'Grupo'        , value: 'grupo'        },
        { text: 'ID prospecto' , value: 'id_prospecto' },
    	]



    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),
    	itemsProspectosAutocomplete() {
    		const idSel = this.alumno.id_prospecto
    		const list = [...this.prospectosBusqueda]
    		if (this.prospectoElegido && this.prospectoElegido.idprospectos === idSel &&
    		    !list.some(p => p.idprospectos === idSel)) {
    			list.unshift(this.prospectoElegido)
    		}
    		return list
    	},
    	textoSinProspectos() {
    		if (this.esFolioRhTexto(this.prospectoSearchInput)) {
    			return 'Eso es un folio RH, no de prospecto. Úsalo en Folio RH (arriba).'
    		}
    		return 'No hay datos disponibles'
    	},
    },

    watch:{
    	prospectoSeleccionado( value){
    		if( value ){
    			this.alumno.folio        = value.matricula
    			this.alumno.nombre       = value.alumno
    			this.alumno.telefono     = value.telefono
    			this.alumno.celular      = value.telefono
    			this.alumno.id_contacto  = value.idprospectos
    			this.alumno.id_prospecto = value.idprospectos
    		}
    	},

    	alumno( ){
  			this.alumno = Object.assign({}, this.alumnoVacio)
  			this.tutor       = Object.assign({}, this.tutorVacio)
  			this.prospectoElegido = null
  			this.prospectosBusqueda = []
  			this.prospectoSearchInput = ''

  			if( this.alumno && this.alumno.idprospectos ){
    			this.alumno.nombre                   = this.alumno.alumno
		    	this.alumno.apellido_paterno         = ''
		    	this.alumno.apellido_materno         = ''
		    	this.alumno.telefono                 = this.alumno.telefono
		    	this.alumno.celular                  = this.alumno.telefono
		    	this.alumno.id_tipo_alumno           = 1
		    	this.alumno.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp
		    	this.alumno.unidad_negocio           = this.getEscuela
		    	this.alumno.id_prospecto             = this.alumno.idprospectos
    		}
    	},

    	prospectoSearchInput(val) {
    		if (this.esFolioRhTexto(val)) {
    			this.prospectosBusqueda = []
    			this.loadingProspectos = false
    			if (this.esFolioRhCompleto(val)) {
    				this.alumno.folio_rh = this.normalizarFolioRh(val)
    				this.onFolioRhInput(this.alumno.folio_rh, this.aplicarFolioRhAlumno)
    			}
    			return
    		}
    		if (this._debounceProspectos) clearTimeout(this._debounceProspectos)
    		this._debounceProspectos = setTimeout(() => {
    			this.buscarProspectosRemoto(val)
    		}, 400)
    	},
    },

    beforeDestroy() {
    	if (this._debounceProspectos) clearTimeout(this._debounceProspectos)
    },

    async created () {
    	this.escuela = this.getEscuela

    	this.alumno.unidad_negocio = this.getEscuela

    	await this.getEmpleadosActivos( )
    },

    methods: {
    	/** Mínimo 3 caracteres de texto, o 1+ si es solo números (folio). */
    	debeBuscarProspectos(q) {
    		const t = (q || '').trim()
    		if (!t) return false
    		if (/^\d+$/.test(t)) return t.length >= 1
    		return t.length >= 3
    	},

    	/**
    	 * El endpoint inscripciones.prospectos.busqueda debe aceptar query opcional:
    	 *   buscar=<texto o id>  y  limit=<n> (ej. 50)
    	 * Si el backend aún devuelve todo el catálogo sin filtrar, hay que actualizar la API;
    	 * de lo contrario el navegador seguirá saturándose.
    	 */
    	buscarProspectosRemoto(q) {
    		const termino = (q || '').trim()
    		if (this.esFolioRhTexto(termino) || !this.debeBuscarProspectos(termino)) {
    			this.prospectosBusqueda = []
    			this.loadingProspectos = false
    			return
    		}
    		this.loadingProspectos = true
    		const params = {
    			buscar: termino,
    			limit: 50,
    			escuela: this.getEscuela,
    		}
    		return this.$http.get('inscripciones.prospectos.busqueda', { params }).then(response => {
    			const data = response.data
    			this.prospectosBusqueda = Array.isArray(data) ? data : []
    		}).catch(error => {
    			this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al buscar prospectos')
    			this.prospectosBusqueda = []
    		}).finally(() => {
    			this.loadingProspectos = false
    		})
    	},

    	aplicarProspectoAlAlumno(item) {
    		if (!item) return
    		this.alumno.folio = item.matricula
    		this.alumno.nombre = item.alumno
    		this.alumno.telefono = item.telefono
    		this.alumno.celular = item.telefono
    		this.alumno.id_contacto = item.idprospectos
    	},

    	onProspectoAutocompleteInput(id) {
    		if (!id) {
    			this.prospectoElegido = null
    			return
    		}
    		const item = this.itemsProspectosAutocomplete.find(p => p.idprospectos === id)
    		if (item) {
    			this.prospectoElegido = { ...item }
    			this.aplicarProspectoAlAlumno(item)
    		}
    	},

      abrirDialogProspecto( ){
      	this.existeProspecto              = true
      	this.parametrosProspectos.estatus = true
      },

      getEmpleadosActivos( ){
    		this.cargar    = true
      	this.empleados = []

        return this.$http.get('usuarios.activos').then(response=>{
        	this.empleados = response.data
        	this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
    	},

      aplicarFolioRhAlumno (info) {
        if (!this.alumno) return
        this.alumno.folio_rh = info.folio_rh
        if (info.id_usuario) {
          this.alumno.id_empleado = info.id_usuario
        }
      },

      saveProspecto( value ){
        this.alumno.nombre                   = value.nombre_completo
	    	this.alumno.apellido_paterno         = ''
	    	this.alumno.apellido_materno         = ''
	    	this.alumno.telefono                 = value.telefono
	    	this.alumno.celular                  = value.telefono
	    	this.alumno.id_tipo_alumno           = 1
	    	this.alumno.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp
	    	this.alumno.unidad_negocio           = this.getEscuela
	    	this.alumno.id_prospecto             = value.idprospectos
	    	this.existeMatricula                 = false
    		const item = {
    			...value,
    			idprospectos: value.idprospectos,
    			datos_completos: value.datos_completos || value.nombre_completo || '',
    			alumno: value.alumno || value.nombre_completo,
    			matricula: value.matricula,
    			telefono: value.telefono,
    		}
    		this.prospectoElegido = item
    		this.prospectosBusqueda = [item]
    		this.prospectoSearchInput = item.datos_completos
      },

      // getAlumnos( ) {
      // 	this.cargar = true
      // 	this.alumnos = []
      //   return this.$http.get('inscripciones.alumnos').then(response=>{
      //   	this.cargar = false
      //   	this.alumnos = response.data
      //   }).catch( error =>{
      //     this.validarError( error.response.data.message )
      //   }).finally( () => { this.cargar = false })
      // },
    },
  }
</script>
